import {makeStyles} from '@material-ui/core/styles'
import {TextButton} from '../../1elements'
import SaveButton from '../../1elements/Buttons/TextButtons/SaveButton'

const PreviewFooter = () => {
    const classes = useStyles()

    const handleResetPreview = () =>{
        const previewMode = localStorage.getItem('previewMode')
        const resetAppearance = () => {
            const selectedColor = localStorage.getItem('colorSelect')
            const selectedFont = localStorage.getItem('fontStyleSelect')
            const selectedIcon = localStorage.getItem('iconsSelect')
            localStorage.setItem('tempColorSelect', selectedColor)
            localStorage.setItem('tempFontStyleSelect', selectedFont)
            localStorage.setItem('tempIconSelect', selectedIcon)

            // TODO Call api to fetch the actual data
            localStorage.setItem('colorSelect', 'Default')
            localStorage.setItem('fontStyleSelect', 'Default')
            localStorage.setItem('iconsSelect', 'Default')
        }
        const resetMap = () => {
            const mapCentralization = localStorage.getItem('mapCentralization')
            localStorage.setItem('tempMapCentralization', mapCentralization)
            // TODO Call api to fetch the actual data
            localStorage.setItem('mapCentralization', mapCentralization)
        }
        switch (previewMode){
            case 'appearance':
                resetAppearance()
                // NOTE, without breakstatements, this would have
                // happened, it would have ran 'resetMap' after, so
                // I put that here to retain the older functionality.
                resetMap()
                break
            case 'map':
                resetMap()
                break
            default:
        }

        localStorage.removeItem('previewMode')
        window.location.replace('/adminDashboard');
    }

    return (
        <div className={classes.root}>
            <TextButton clickHandler={handleResetPreview} secondaryButton>Cancel Preview</TextButton>
            <SaveButton />
        </div>
    )
}

export default PreviewFooter

const useStyles = makeStyles((theme)=>({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        position: 'absolute',
        backgroundColor: theme.palette.quaternary.main,
        width: '100%',
        bottom: 0,
        padding: 10,
        zIndex: 2,
        '&>*': {
            marginLeft: 20
        }
    }
}))